module OnlineDPR.Application.Client.State

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Client.Types
open OnlineDPR.Application.Client.Report
open OnlineDPR.Application.Client.Page

open Elmish
open Fable.Core.JsInterop
open Fable.Import
open Thoth.Json

let init result =
    let stateJson: string option = !!Browser.Dom.window?__INIT_MODEL__
    match stateJson with
    | Some json ->
        match Decode.Auto.fromString (json, extra = Encoders.extra) with
        | Ok model -> model, []
        | Error e -> failwith e
    | None ->
        match currentPage with
        | Page.UserSync ->
            let pageModel, cmds = UserSync.init()
            { PageModel = pageModel }, Cmd.map UserSyncMessage cmds
        | Page.RawDataInput ->
            let pageModel, cmds = DprInput.init(Template.Default)
            { PageModel = pageModel }, Cmd.map UserDataInputMessage cmds
        | Page.UpdateTranslations ->
            let pageModel, cmds = UpdateTranslations.init()
            { PageModel = pageModel }, Cmd.map UpdateTranslationsMessage cmds
        | Page.BwaOverview ->
            let pageModel, cmds = BwaOverview.init()
            { PageModel = pageModel }, Cmd.map BwaOverviewMessage cmds
        | Page.DprAdministration ->
            let pageModel, cmds = DprAdministration.init()
            { PageModel = pageModel }, Cmd.map DprAdministrationMessage cmds
        | Page.ClubList ->
            let pagemodel, cmds = ClubList.init()
            { PageModel = pagemodel}, Cmd.map ClubListMessage cmds
        | Page.Invoices ->
            let pageModel, cmds = Invoices.init()
            { PageModel = pageModel }, cmds
        | _ ->
            { PageModel = BlankPageModel }, []

let update msg model =
  match msg, model.PageModel with
  | ReportMessage msg, ReportPageModel m  ->
        let (submodel, cmds) = Report.update msg m
        { model with PageModel = ReportPageModel submodel }, Cmd.map ReportMessage cmds
  | UserSyncMessage msg, UserSyncPageModel m ->
        let (submodel, commands) = UserSync.update msg m
        { model with PageModel = UserSyncPageModel submodel }, Cmd.map UserSyncMessage commands
  | UserDataInputMessage msg, DprInputModel m ->
        let (submodel, cmds) = DprInput.update msg m
        { model with PageModel = DprInputModel submodel }, Cmd.map UserDataInputMessage cmds
  | BwaInputMessage msg, BwaInputModel m ->
        let (submodel, cmds) = BwaInput.update msg m
        { model with PageModel = BwaInputModel submodel }, Cmd.map BwaInputMessage cmds
  | UpdateTranslationsMessage msg, UpdateTranslationsModel m ->
        let (submodel, cmds) = UpdateTranslations.update msg m
        { model with PageModel = UpdateTranslationsModel submodel}, Cmd.map UpdateTranslationsMessage cmds
  | ClubListMessage msg, ClubListModel m ->
        let (submodel, cmds) = ClubList.update msg m
        { model with PageModel = ClubListModel submodel }, Cmd.map ClubListMessage cmds
  | ControlPanelDprMessage msg, ControlPanelDprModel m ->
        let (submodel, cmds) = ControlPanelDpr.update msg m
        { model with PageModel = ControlPanelDprModel submodel }, Cmd.map ControlPanelDprMessage cmds
  | BwaOverviewMessage msg, BwaOverviewModel m ->
        let (submodel, cmds) = BwaOverview.update msg m
        {model with PageModel = BwaOverviewModel submodel }, Cmd.map BwaOverviewMessage cmds
  | ControlPanelMessage msg, ControlPanelModel m ->
        let (submodel, cmds) = ControlPanel.update msg m
        {model with PageModel = ControlPanelModel submodel }, Cmd.map ControlPanelMessage cmds
  | InvoicesMessage msg, InvoicesModel m ->
        let (submodel, cmds) = Invoices.update msg m
        {model with PageModel = InvoicesModel submodel }, Cmd.map InvoicesMessage cmds
  | ControlPanelBwaMessage msg, ControlPanelBwaModel m ->
        let (submodel, cmds) = ControlPanelBwa.update msg m
        {model with PageModel = ControlPanelBwaModel submodel }, Cmd.map ControlPanelBwaMessage cmds
  | DprAdministrationMessage msg, DprAdministrationModel m ->
        let (submodel, cmds) = DprAdministration.update msg m
        {model with PageModel = DprAdministrationModel submodel }, Cmd.map DprAdministrationMessage cmds
  | _, _ -> failwith "message handler not implemented"